import { ColumnsType } from 'antd/es/table';
import { observer } from 'mobx-react-lite';
import { Trans } from 'react-i18next';
import { DataView } from 'src/components/DataView/DataView';
import { Table } from 'src/components/Table/Table';
import { ReassignmentDto } from 'src/generated-api-client';
import { LoanApplicationReassignmentsStore } from 'src/stores/LoanApplicationReassignmentsStore/LoanApplicationReassignmentsStore';

const store = LoanApplicationReassignmentsStore;

export const LoanApplicationReassignmentReasonsTable = observer(() => {
    return (
        <Table
            columns={columns}
            dataSource={store.list}
            loading={store.listLoader.isLoading}
            pagination={false}
        />
    );
});

const columns: ColumnsType<ReassignmentDto> = [
    {
        title: <Trans i18nKey="LoanApplication.ReassignmentReasons.BoUser" />,
        dataIndex: 'createdBy',
        key: 'createdBy',
        render: (value) => {
            return <DataView value={value} />;
        },
    },
    {
        title: (
            <Trans i18nKey="LoanApplication.ReassignmentReasons.ReassignedAt" />
        ),
        dataIndex: 'reassignedAt',
        key: 'reassignedAt',
        render: (value) => {
            return <DataView value={value} formatValue="dateTimeSeconds" />;
        },
    },
    {
        title: (
            <Trans i18nKey="LoanApplication.ReassignmentReasons.ReassignmentReason" />
        ),
        dataIndex: 'reassignmentReason',
        key: 'reassignmentReason',
        render: (value) => {
            return <DataView value={value} />;
        },
    },
];
